module.exports = __webpack_public_path__ + "static/media/reels.fd0fb0f4.png";